export interface FontCatalogEntry {
  // These are currently identical for bundled Google fonts, but kept separate so
  // persisted value, display label, and CSS family can diverge in the future.
  value: string
  label: string
  family: string
  weights: readonly number[]
}

export const DEFAULT_TEXT_FONT_FAMILY = 'Inter'

export const FONT_CATALOG: readonly FontCatalogEntry[] = [
  {
    value: 'Roboto',
    label: 'Roboto',
    family: 'Roboto',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Open Sans',
    label: 'Open Sans',
    family: 'Open Sans',
    weights: [300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Google Sans',
    label: 'Google Sans',
    family: 'Google Sans',
    weights: [400, 500, 600, 700],
  },
  {
    value: 'Noto Sans JP',
    label: 'Noto Sans JP',
    family: 'Noto Sans JP',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Inter',
    label: 'Inter',
    family: 'Inter',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Montserrat',
    label: 'Montserrat',
    family: 'Montserrat',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Poppins',
    label: 'Poppins',
    family: 'Poppins',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Lato', label: 'Lato', family: 'Lato', weights: [100, 300, 400, 700, 900] },
  {
    value: 'Roboto Condensed',
    label: 'Roboto Condensed',
    family: 'Roboto Condensed',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Roboto Mono',
    label: 'Roboto Mono',
    family: 'Roboto Mono',
    weights: [100, 200, 300, 400, 500, 600, 700],
  },
  { value: 'Arimo', label: 'Arimo', family: 'Arimo', weights: [400, 500, 600, 700] },
  { value: 'Oswald', label: 'Oswald', family: 'Oswald', weights: [200, 300, 400, 500, 600, 700] },
  {
    value: 'Noto Sans',
    label: 'Noto Sans',
    family: 'Noto Sans',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Raleway',
    label: 'Raleway',
    family: 'Raleway',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Nunito',
    label: 'Nunito',
    family: 'Nunito',
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
  },
  {
    value: 'Nunito Sans',
    label: 'Nunito Sans',
    family: 'Nunito Sans',
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
  },
  {
    value: 'Playfair Display',
    label: 'Playfair Display',
    family: 'Playfair Display',
    weights: [400, 500, 600, 700, 800, 900],
  },
  { value: 'Rubik', label: 'Rubik', family: 'Rubik', weights: [300, 400, 500, 600, 700, 800, 900] },
  { value: 'Ubuntu', label: 'Ubuntu', family: 'Ubuntu', weights: [300, 400, 500, 700] },
  {
    value: 'Roboto Slab',
    label: 'Roboto Slab',
    family: 'Roboto Slab',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'DM Sans',
    label: 'DM Sans',
    family: 'DM Sans',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
  },
  {
    value: 'Merriweather',
    label: 'Merriweather',
    family: 'Merriweather',
    weights: [300, 400, 700, 900],
  },
  {
    value: 'Noto Sans KR',
    label: 'Noto Sans KR',
    family: 'Noto Sans KR',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Work Sans',
    label: 'Work Sans',
    family: 'Work Sans',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'PT Sans', label: 'PT Sans', family: 'PT Sans', weights: [400, 700] },
  {
    value: 'Kanit',
    label: 'Kanit',
    family: 'Kanit',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Lora', label: 'Lora', family: 'Lora', weights: [400, 500, 600, 700] },
  {
    value: 'Mulish',
    label: 'Mulish',
    family: 'Mulish',
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
  },
  { value: 'Fjalla One', label: 'Fjalla One', family: 'Fjalla One', weights: [400] },
  {
    value: 'Manrope',
    label: 'Manrope',
    family: 'Manrope',
    weights: [200, 300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Archivo',
    label: 'Archivo',
    family: 'Archivo',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Quicksand',
    label: 'Quicksand',
    family: 'Quicksand',
    weights: [300, 400, 500, 600, 700],
  },
  {
    value: 'Outfit',
    label: 'Outfit',
    family: 'Outfit',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Figtree',
    label: 'Figtree',
    family: 'Figtree',
    weights: [300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Fira Sans',
    label: 'Fira Sans',
    family: 'Fira Sans',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Inconsolata',
    label: 'Inconsolata',
    family: 'Inconsolata',
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Barlow',
    label: 'Barlow',
    family: 'Barlow',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Bebas Neue', label: 'Bebas Neue', family: 'Bebas Neue', weights: [400] },
  {
    value: 'Noto Sans TC',
    label: 'Noto Sans TC',
    family: 'Noto Sans TC',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Archivo Black', label: 'Archivo Black', family: 'Archivo Black', weights: [400] },
  {
    value: 'Source Sans 3',
    label: 'Source Sans 3',
    family: 'Source Sans 3',
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Hind Siliguri',
    label: 'Hind Siliguri',
    family: 'Hind Siliguri',
    weights: [300, 400, 500, 600, 700],
  },
  {
    value: 'IBM Plex Sans',
    label: 'IBM Plex Sans',
    family: 'IBM Plex Sans',
    weights: [100, 200, 300, 400, 500, 600, 700],
  },
  {
    value: 'Prompt',
    label: 'Prompt',
    family: 'Prompt',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Bungee', label: 'Bungee', family: 'Bungee', weights: [400] },
  {
    value: 'Titillium Web',
    label: 'Titillium Web',
    family: 'Titillium Web',
    weights: [200, 300, 400, 600, 700, 900],
  },
  { value: 'Karla', label: 'Karla', family: 'Karla', weights: [200, 300, 400, 500, 600, 700, 800] },
  {
    value: 'Heebo',
    label: 'Heebo',
    family: 'Heebo',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Saira',
    label: 'Saira',
    family: 'Saira',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Noto Serif',
    label: 'Noto Serif',
    family: 'Noto Serif',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'PT Serif', label: 'PT Serif', family: 'PT Serif', weights: [400, 700] },
  {
    value: 'Jost',
    label: 'Jost',
    family: 'Jost',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Plus Jakarta Sans',
    label: 'Plus Jakarta Sans',
    family: 'Plus Jakarta Sans',
    weights: [200, 300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Bricolage Grotesque',
    label: 'Bricolage Grotesque',
    family: 'Bricolage Grotesque',
    weights: [200, 300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Noto Color Emoji',
    label: 'Noto Color Emoji',
    family: 'Noto Color Emoji',
    weights: [400],
  },
  { value: 'Share Tech', label: 'Share Tech', family: 'Share Tech', weights: [400] },
  {
    value: 'Smooch Sans',
    label: 'Smooch Sans',
    family: 'Smooch Sans',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Source Code Pro',
    label: 'Source Code Pro',
    family: 'Source Code Pro',
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Libre Baskerville',
    label: 'Libre Baskerville',
    family: 'Libre Baskerville',
    weights: [400, 700],
  },
  {
    value: 'Dancing Script',
    label: 'Dancing Script',
    family: 'Dancing Script',
    weights: [400, 500, 600, 700],
  },
  { value: 'Lobster Two', label: 'Lobster Two', family: 'Lobster Two', weights: [400, 700] },
  {
    value: 'EB Garamond',
    label: 'EB Garamond',
    family: 'EB Garamond',
    weights: [400, 500, 600, 700, 800],
  },
  {
    value: 'Josefin Sans',
    label: 'Josefin Sans',
    family: 'Josefin Sans',
    weights: [100, 200, 300, 400, 500, 600, 700],
  },
  {
    value: 'Cairo',
    label: 'Cairo',
    family: 'Cairo',
    weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000],
  },
  {
    value: 'Libre Franklin',
    label: 'Libre Franklin',
    family: 'Libre Franklin',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Gravitas One', label: 'Gravitas One', family: 'Gravitas One', weights: [400] },
  {
    value: 'Noto Serif JP',
    label: 'Noto Serif JP',
    family: 'Noto Serif JP',
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Public Sans',
    label: 'Public Sans',
    family: 'Public Sans',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Anton', label: 'Anton', family: 'Anton', weights: [400] },
  { value: 'Mukta', label: 'Mukta', family: 'Mukta', weights: [200, 300, 400, 500, 600, 700, 800] },
  {
    value: 'Schibsted Grotesk',
    label: 'Schibsted Grotesk',
    family: 'Schibsted Grotesk',
    weights: [400, 500, 600, 700, 800, 900],
  },
  { value: 'Dosis', label: 'Dosis', family: 'Dosis', weights: [200, 300, 400, 500, 600, 700, 800] },
  {
    value: 'Barlow Condensed',
    label: 'Barlow Condensed',
    family: 'Barlow Condensed',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Bitter',
    label: 'Bitter',
    family: 'Bitter',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Roboto Flex',
    label: 'Roboto Flex',
    family: 'Roboto Flex',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
  },
  { value: 'Cabin', label: 'Cabin', family: 'Cabin', weights: [400, 500, 600, 700] },
  {
    value: 'Noto Sans SC',
    label: 'Noto Sans SC',
    family: 'Noto Sans SC',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Ramabhadra', label: 'Ramabhadra', family: 'Ramabhadra', weights: [400] },
  {
    value: 'Noto Sans Telugu',
    label: 'Noto Sans Telugu',
    family: 'Noto Sans Telugu',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Nanum Gothic',
    label: 'Nanum Gothic',
    family: 'Nanum Gothic',
    weights: [400, 700, 800],
  },
  {
    value: 'Space Grotesk',
    label: 'Space Grotesk',
    family: 'Space Grotesk',
    weights: [300, 400, 500, 600, 700],
  },
  { value: 'Changa One', label: 'Changa One', family: 'Changa One', weights: [400] },
  {
    value: 'Anek Telugu',
    label: 'Anek Telugu',
    family: 'Anek Telugu',
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Assistant',
    label: 'Assistant',
    family: 'Assistant',
    weights: [200, 300, 400, 500, 600, 700, 800],
  },
  { value: 'Oxygen', label: 'Oxygen', family: 'Oxygen', weights: [300, 400, 700] },
  { value: 'Pacifico', label: 'Pacifico', family: 'Pacifico', weights: [400] },
  { value: 'Alfa Slab One', label: 'Alfa Slab One', family: 'Alfa Slab One', weights: [400] },
  {
    value: 'Lexend',
    label: 'Lexend',
    family: 'Lexend',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Hind', label: 'Hind', family: 'Hind', weights: [300, 400, 500, 600, 700] },
  {
    value: 'M PLUS Rounded 1c',
    label: 'M PLUS Rounded 1c',
    family: 'M PLUS Rounded 1c',
    weights: [100, 300, 400, 500, 700, 800, 900],
  },
  {
    value: 'Red Hat Display',
    label: 'Red Hat Display',
    family: 'Red Hat Display',
    weights: [300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Exo 2',
    label: 'Exo 2',
    family: 'Exo 2',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Slabo 27px', label: 'Slabo 27px', family: 'Slabo 27px', weights: [400] },
  { value: 'Lobster', label: 'Lobster', family: 'Lobster', weights: [400] },
  {
    value: 'Cormorant Garamond',
    label: 'Cormorant Garamond',
    family: 'Cormorant Garamond',
    weights: [300, 400, 500, 600, 700],
  },
  {
    value: 'Sora',
    label: 'Sora',
    family: 'Sora',
    weights: [100, 200, 300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Crimson Text',
    label: 'Crimson Text',
    family: 'Crimson Text',
    weights: [400, 600, 700],
  },
  {
    value: 'Inter Tight',
    label: 'Inter Tight',
    family: 'Inter Tight',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Overpass',
    label: 'Overpass',
    family: 'Overpass',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Caveat', label: 'Caveat', family: 'Caveat', weights: [400, 500, 600, 700] },
  {
    value: 'Urbanist',
    label: 'Urbanist',
    family: 'Urbanist',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Comfortaa',
    label: 'Comfortaa',
    family: 'Comfortaa',
    weights: [300, 400, 500, 600, 700],
  },
  {
    value: 'Tajawal',
    label: 'Tajawal',
    family: 'Tajawal',
    weights: [200, 300, 400, 500, 700, 800, 900],
  },
  { value: 'Arvo', label: 'Arvo', family: 'Arvo', weights: [400, 700] },
  {
    value: 'PT Sans Narrow',
    label: 'PT Sans Narrow',
    family: 'PT Sans Narrow',
    weights: [400, 700],
  },
  { value: 'Rajdhani', label: 'Rajdhani', family: 'Rajdhani', weights: [300, 400, 500, 600, 700] },
  {
    value: 'DM Serif Display',
    label: 'DM Serif Display',
    family: 'DM Serif Display',
    weights: [400],
  },
  { value: 'Abel', label: 'Abel', family: 'Abel', weights: [400] },
  { value: 'Teko', label: 'Teko', family: 'Teko', weights: [300, 400, 500, 600, 700] },
  {
    value: 'Source Serif 4',
    label: 'Source Serif 4',
    family: 'Source Serif 4',
    weights: [200, 300, 400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Noto Sans Arabic',
    label: 'Noto Sans Arabic',
    family: 'Noto Sans Arabic',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Almarai', label: 'Almarai', family: 'Almarai', weights: [300, 400, 700, 800] },
  {
    value: 'Merriweather Sans',
    label: 'Merriweather Sans',
    family: 'Merriweather Sans',
    weights: [300, 400, 500, 600, 700, 800],
  },
  {
    value: 'Lexend Deca',
    label: 'Lexend Deca',
    family: 'Lexend Deca',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Satisfy', label: 'Satisfy', family: 'Satisfy', weights: [400] },
  {
    value: 'Orbitron',
    label: 'Orbitron',
    family: 'Orbitron',
    weights: [400, 500, 600, 700, 800, 900],
  },
  {
    value: 'Barlow Semi Condensed',
    label: 'Barlow Semi Condensed',
    family: 'Barlow Semi Condensed',
    weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  },
  { value: 'Domine', label: 'Domine', family: 'Domine', weights: [400, 500, 600, 700] },
  {
    value: 'Shadows Into Light',
    label: 'Shadows Into Light',
    family: 'Shadows Into Light',
    weights: [400],
  },
  {
    value: 'M PLUS 1p',
    label: 'M PLUS 1p',
    family: 'M PLUS 1p',
    weights: [100, 300, 400, 500, 700, 800, 900],
  },
]
